import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TwoFa from "../../elements/twoFa/TwoFa";
import DialogModal from "../../elements/dialogModal/DialogModal";
import { check2FA } from "../../../utils/check2FA";
import getUserInfo from "../../../utils/getUserInfo";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { parseAxiosError } from "../../../utils/response";

import MaterialSwitch from "../../styles/materialSwitch";

const UserServicesSwitch = ({ userId, userService, refetch, notification, setNotification }) => {

  const { t } = useTranslation("servicePage");
  const [error, setError] = useState({});
  const [open, setOpen] = useState(false);
  const [changeService, setChangeService] = useState({
    serviceId: null,
    userServiceId: null
  });

  const handleChange = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    if (!changeService.userServiceId) {
      let data = {
        user: userId,
        service: changeService.serviceId
      };

      createUserService(data);
    } else {
      deleteUserService(changeService.userServiceId);
    }
  };

  const createUserService = (data) => {
    axios.post("/api/user-services", data, userAuthenticationConfig(false)).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_CREATED) {
        setOpen(false);
        refetch();
        setNotification({
          ...notification,
          visible: true,
          type: "success",
          message: t("list.success")
        });
      }
    }).catch(error => {
      setOpen(false);
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const deleteUserService = (userServiceId) => {
    axios.delete("/api/user-services/" + userServiceId, userAuthenticationConfig()).then(response => {
      setOpen(false);
      refetch();
      setNotification({
        ...notification,
        visible: true,
        type: "success",
        message: t("list.success")
      });
    }).catch(error => {
      setOpen(false);
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("details.addForm.twoFaTitle")}
        content={<TwoFa
          handleSubmit={handleChange}
          error={error}
        />}
      />
      <MaterialSwitch
        checked={!!userService.userServiceId}
        onChange={() => {
          setChangeService({ ...changeService, serviceId: userService.id, userServiceId: userService.userServiceId });
          setOpen(true);
        }}
      />
    </>
  );
};
export default UserServicesSwitch;